import { connect } from 'react-redux';
import ViewSwitch from '../ViewSwitch/ViewSwitch';
import UILocale from '../../translations/UILocale.js';
import { setSelectedUserView, showFlexibleCreditTooltip } from '../../reduck/listingPageCommonData.reduck';
import UISettings from '../../settings/UISettings';


const mapStateToProps = (state) => ({
  activeView: state.listingPage.commonData.xhrStatus.pendingProductsRequest
    ? 'none'
    : state.listingPage.commonData.selectedUserView || UISettings.get('defaultViewForThisSegment') ||
    UISettings.get('defaultView'),
  title: UILocale.getString('component.viewswitch.title'),
  gridButtonLabel: UILocale.getString('component.viewswitch.grid_button_label'),
  listButtonLabel: UILocale.getString('component.viewswitch.list_button_label')
});

const mapDispatchToProps = (dispatch) => ({
  onEnabledButtonClick: (e) => {
    // online credit tooltip has to closed before switch to a different view
    dispatch(showFlexibleCreditTooltip(null));
    dispatch(setSelectedUserView(e.activeView));
    // set cookie called 'layout' for user's selected active view
    document.cookie = `layout=${e.activeView};path=/`;
    // the old listing page set wrongly domain for this cookie to '.domain' (e.g. '.www.currys.co.uk' on production)
    // so this line fixs this
    // TODO: remove this line as soon as old listing page is completely removed
    document.cookie = `layout=${e.activeView};path=/;domain=.${window.location.hostname}`;
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewSwitch);
